import React, { Fragment } from "react";
import { Row, Col, Modal, ModalHeader, ModalBody, Label, Form, FormGroup, CardHeader, Card, CardBody } from "reactstrap";


const ViewChangeHistoryModal = ({isOpen, toggle, changeExistingHistory, changeNewHistory, data, mappingFuel, mappingTransmission, model, variant}) => {

    return (
        <Fragment>
            <Modal isOpen={isOpen} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle} className="border-0">{"View Change History"}</ModalHeader>
                <ModalBody>
                    <Form className="needs-validation" noValidate>
                        <Row>
                            <Col xl="6" md="6">
                                <Card style={{ background: '#EAEDED' }}>
                                    <CardHeader className="border-0 mb-0 pb-0" style={{ background: '#EAEDED' }}>
                                        <h6>{"Old Details"}</h6>
                                    </CardHeader>
                                    <CardBody style={{ fontSize: '11px' }}>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"NAME"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{changeExistingHistory?.name}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"EMAIL"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{changeExistingHistory?.email}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"LOCATION"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{changeExistingHistory?.state} {" - "} {changeExistingHistory?.city}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>


                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"Model"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{data?.vehicle?.model_id}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"Variant"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{data?.vehicle?.variant_id}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"Transmission"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{data?.vehicle?.transmission_id}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"Fuel"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{data?.vehicle?.fuel_id}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"CREATED AT"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{data?.policy_history?.requested_at}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                    </CardBody>
                                </Card>

                            </Col>

                            <Col xl="6" md="6">
                                <Card style={{ background: '#EAEDED' }}>
                                    <CardHeader className="border-0 mb-0 pb-0" style={{ background: '#EAEDED' }}>
                                        <h6>{"New Details"}</h6>
                                    </CardHeader>
                                    <CardBody style={{ fontSize: '11px' }}>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"NAME"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{changeNewHistory?.name}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"EMAIL"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{changeNewHistory?.email}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"LOCATION"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{changeNewHistory?.state} {" - "} {changeNewHistory?.city}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"Model"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    {/* <Label>{model[changeNewHistory?.model_id]}</Label> */}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"Variant"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    {/* <Label>{variant[changeNewHistory?.variant_id]}</Label> */}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"Transmission"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    {/* <Label>{mappingTransmission[changeNewHistory?.transmission_id]}</Label> */}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"Fuel"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    {/* <Label>{mappingFuel[changeNewHistory?.fuel_id]}</Label> */}
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col xl="4" md="4">
                                                <FormGroup>
                                                    <Label>{"CREATED AT"}</Label>
                                                </FormGroup>
                                            </Col>
                                            <Col xl="8" md="8" className='text-right'>
                                                <FormGroup>
                                                    <Label>{data?.policy_history?.requested_at}</Label>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </CardBody>
                                </Card>

                            </Col>

                        </Row>

                    </Form>
                </ModalBody>
            </Modal>
        </Fragment>
    );
};

export default ViewChangeHistoryModal;
